import YoutubeLikeTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/youtube/triggers/like/InstructionsComponent';
import type {TriggerIntegration} from '@cohort/merchants/apps';
import useSocialStepCompletionColumns from '@cohort/merchants/apps/common/triggers/useSocialStepCompletionColumns';
import YoutubeLikeTriggerActionCtaComponentPreview from '@cohort/merchants/apps/youtube/triggers/like/ActionCtaComponentPreview';
import YoutubeLikeTriggerIntegrationConfigComponent from '@cohort/merchants/apps/youtube/triggers/like/ConfigComponent';
import YoutubeLikeTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/youtube/triggers/like/StepCompletionTitleComponent';
import YoutubeLikeTriggerIntegrationComponentPreview from '@cohort/merchants/apps/youtube/triggers/like/TriggerComponentPreview';
import type {YoutubeLikeTriggerStruct} from '@cohort/shared/apps/youtube/triggers/like';
import {YoutubeLikeTriggerSpec} from '@cohort/shared/apps/youtube/triggers/like';

export const YoutubeLikeTriggerIntegration: TriggerIntegration<YoutubeLikeTriggerStruct> = {
  spec: YoutubeLikeTriggerSpec,
  configComponent: YoutubeLikeTriggerIntegrationConfigComponent,
  stepCompletionTitleComponent: YoutubeLikeTriggerIntegrationStepCompletionTitleComponent,
  useStepCompletionColumns: context =>
    useSocialStepCompletionColumns<YoutubeLikeTriggerStruct>({
      ...context,
      userNameKey: 'channelHandle',
    }),
  getTitle: t => t('triggerIntegrations.like.title', {ns: 'app-youtube'}),
  preview: {
    InstructionsComponent: YoutubeLikeTriggerIntegrationInstructionsComponent,
    CtaComponent: YoutubeLikeTriggerActionCtaComponentPreview,
    TriggerComponent: YoutubeLikeTriggerIntegrationComponentPreview,
  },
};
